import { Project } from '../reducers/projectReducer'

export enum ProjectActionTypes {
    GET_PROJECTS_REQUEST = 'PROJECTS/GET_PROJECTS_REQUEST',
    GET_PROJECTS_SUCCESS = 'PROJECTS/GET_PROJECTS_SUCCESS',
    GET_PROJECTS_FAILURE = 'PROJECTS/GET_PROJECTS_FAILURE',

    CREATE_PROJECT_REQUEST = 'PROJECTS/CREATE_PROJECT_REQUEST',
    CREATE_PROJECT_SUCCESS = 'PROJECTS/CREATE_PROJECT_SUCCESS',
    CREATE_PROJECT_FAILURE = 'PROJECTS/CREATE_PROJECT_FAILURE',

    GET_PROJECT_DETAILS_REQUEST = 'PROJECTS/GET_PROJECT_DETAILS_REQUEST',
    GET_PROJECT_DETAILS_SUCCESS = 'PROJECTS/GET_PROJECT_DETAILS_SUCCESS',
    GET_PROJECT_DETAILS_FAILURE = 'PROJECTS/GET_PROJECT_DETAILS_FAILURE',
}

export const getProjectsRequest = (params?: any) => ({
    type: ProjectActionTypes.GET_PROJECTS_REQUEST,
    payload: params,
})

export const getProjectsSuccess = (projects: Project[]) => ({
    type: ProjectActionTypes.GET_PROJECTS_SUCCESS,
    payload: projects,
})

export const getProjectsFailure = (error: string) => ({
    type: ProjectActionTypes.GET_PROJECTS_FAILURE,
    payload: error,
})

export const getProjectDetailsRequest = (id: string) => ({
    type: ProjectActionTypes.GET_PROJECT_DETAILS_REQUEST,
    payload: id,
})

export const getProjectDetailsSuccess = (project: Project) => ({
    type: ProjectActionTypes.GET_PROJECT_DETAILS_SUCCESS,
    payload: project,
})

export const getProjectDetailsFailure = (error: string) => ({
    type: ProjectActionTypes.GET_PROJECT_DETAILS_FAILURE,
    payload: error,
})

export const createProjectRequest = (data: any) => ({
    type: ProjectActionTypes.CREATE_PROJECT_REQUEST,
    payload: data,
})

export const createProjectSuccess = (project: Project) => ({
    type: ProjectActionTypes.CREATE_PROJECT_SUCCESS,
    payload: project,
})

export const createProjectFailure = (error: string) => ({
    type: ProjectActionTypes.CREATE_PROJECT_FAILURE,
    payload: error,
})
